import { Analytics } from '@workivate/tho-web-shared';

export const AnalyticsEvent = Analytics.AnalyticsEventsFactoryHermes({
  measurementId: window.WAM.ENV.analyticsMeasurementId || '',
  debug: !IS_PRODUCTION,
  gtag: typeof window !== 'undefined' ? window.gtag : undefined,
});
